import React from 'react'
import Grid from '@material-ui/core/Grid'

const TopLevelSection = ({ response, sectionId }) => {
  if (!sectionId || !response || !response.nodes) {
    return null
  }

  return (
    <Grid item xs={12}>
      <Grid container className='w-100'>
        <Grid item xs={3} className='pl6'>
          <div className='b'>Section</div>
        </Grid>
        <Grid item xs={9} className='pl7'>
          <div className='pl6'>
            {response.nodes[sectionId].title}
          </div>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TopLevelSection
